<template>
      <div class="d-flex justify-content-center align-items-center mt-15">
        <img src="../../../assets/images/logo-mic.svg" alt="LOGO">
      </div>
      <div class="card border-0 rounded-0 bg-white authentication-card" 
      style="margin-top: 10% !important;border-radius:15px !important;width: 500px;height: auto;">
        <div class="card-body letter-spacing" style="padding: 60px 50px !important;">
          <h4 class="text-black fw-bold mb-0 text-center">
            Veuillez vous connecter!
          </h4>
          <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse e-mail
              </label>
              <Field name="email" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre adresse mail"/>
                <ErrorMessage name="email" class="text-danger"/>
              <!-- <input
                type="text" name="identifiant"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="adresse mail ou identifiant"
              /> -->
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot de passe
              </label>
              <Field name="password" type="password" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer votre email ouu identifiant"/>
                <ErrorMessage name="password" class="text-danger"/>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mb-15 mb-md-20"
            >
              <div
                class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-muted lh-1"
              >
                <input
                  class="form-check-input shadow-none"
                  type="checkbox"
                  id="remember-me"
                />
                <label class="form-check-label" for="remember-me">
                  Se souvenir de moi
                </label>
              </div>
              <!-- <router-link
                to="/forgot-password"
                class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
              >
                Forgot Password?
              </router-link> -->
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              type="submit"
            >
              Se connecter
            </button>

            <!-- <router-link
                to="/Accueil"
                class="default-btn transition border-0 fw-medium text-white text-center rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100"
              >
                Se connecter
              </router-link> -->
            
            
            </Form>
        </div>
      </div>
</template>

<!-- <script>
export default {
  name: "LoginForm",
};
</script> -->

<script lang="ts">
   import { defineComponent, onMounted, reactive, ref, watch } from "vue";
   import { Form, Field, ErrorMessage } from "vee-validate";
   import { error, success, showModal, hideModal } from "../../../utils/utils";
   import { useRoute, useRouter } from "vue-router";
   import ApiService from "../../../services/ApiService";
   import * as Yup from "yup";
   import { useAuthStore } from '@/services/auth';
import Swal from "sweetalert2";
   
   export default defineComponent({
     name: "LoginForm",
     components: {
       Form,
       Field,
       ErrorMessage
     },
     
     setup: () => {
       const elementSchema = Yup.object().shape({
         email: Yup.string().email("L'adresse e-mail est invalide").required("L'adresse e-mail est obligatoire"),
         password: Yup.string().required("Le mot de passe est obligatoire")
       });
   
        const elementForm = ref<null>(null);
        const router  = useRouter();
        const store = useAuthStore();
        const submitButton = ref<HTMLButtonElement | null>(null);
   
        // onMounted(()=> {
            
        // })
   
       
   
       const showA = ref(false)
       const show = ref("0")
   
       const addElement = async (values: any, elementForm) => {

            // Send login request
            await store.login(values);
            const error =  Object.values(store.errors);
            console.log("error", error);
            //const error = [];
            if (error.length === 0) {
                router.push({ name: "ProductsGridPage" });
            } else {
              Swal.fire({
                text: error[1] as string,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "OK",
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-sm fw-semobold btn-danger",
                },
              }).then(() => {
                store.errors = {};
              });
            }

            // console.log("value", values);
            // ApiService.post("/vente",values)
            // .then(({ data }) => {
            //     if(data.code == 201) { 
            //         success(data.message);
            //         router.push('/ventes');
            //         // elementForm.resetForm();
            //     }
            // })
            // .catch(({ response }) => {
            //    // error(response.data.message);
            // });
       };
   
     
   
   
       return { 
            addElement,
            elementSchema,
            elementForm
       };
     },
   });
   </script>